import { useSearchParams } from 'react-router-dom'
import { AiAssistant } from '../components/AiAssistant'
import type { AiIntent } from '../types'

const allowed = new Set<AiIntent>(['explain', 'compare', 'hint', 'quiz_feedback', 'chart_explanation', 'calculation_explanation', 'next_step', 'semantic_search'])

export function AskPage() {
  const [params] = useSearchParams()
  const requestedIntent = params.get('intent') as AiIntent | null
  const intent = requestedIntent && allowed.has(requestedIntent) ? requestedIntent : 'explain'
  const query = params.get('q') ?? ''
  return <div className="page-width page-stack ask-page"><AiAssistant initialIntent={intent} initialQuery={query} /></div>
}
